<script setup>
import VideoPlayer from '../../VideoPlayer.vue'

defineProps({
  item: Object,
})

const params = new URLSearchParams(window.location.search)
// Audio playback is disabled by default because of browser autoplay policies, but can be enabled by adding `?allowAudio=true` to the URL query parameters.
// Usually, graphics playout engines are configured to have this browser limitation disabled. In those cases, the `allowAudio` parameter can be set to `true` to enable audio playback.
const allowAudio = params.has('allowAudio') && params.get('allowAudio') !== 'false'
</script>

<template>
  <VideoPlayer class="absolute top-0 left-0 w-full h-full object-contain object-left" :src="item.properties.video" :loop="item.properties.loop" autoplay :muted="!allowAudio" />
</template>
